// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Mint from 'mint-ui'
import router from './router'
import 'mint-ui/lib/style.css'
import axios from './axios/http'
import store from './vuex/store'

Vue.use(Mint)
Vue.prototype.$axios = axios
Vue.config.productionTip = false

router.afterEach((to, from, next) => {
  document.title = to.meta.title
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js